import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationFinding = createCrudVuexModule({
  namespaced: true,
  path: "/audit-control/finding",
  moduleName: "organizationFinding",
  options: {
    localizedFields: ["name", "description"],
  },
  actions: {},
});
